import React, { useState, useEffect } from "react";
import { Button, Spinner, Alert } from "react-bootstrap";
import HeroSection from "./ProfileComponents/HeroSection";
import MetaSection from "./ProfileComponents/MetaSection";
import { sanitizeData } from ".";

const SimpleMainPageEditor = ({ data, onSave, onCancel, isLoading }) => {
  const defaultStructure = {
    heroSection: {
      title: "",
      backgroundImage: "",
      isVisible: true,
    },
    meta: {
      title: "",
      description: "",
    },
  };

  const [formData, setFormData] = useState(defaultStructure);
  const [alert, setAlert] = useState({ show: false, message: "", variant: "info" });

  useEffect(() => {
    if (data?.content) {
      setFormData({ ...defaultStructure, ...data.content });
    }
  }, [data]);

  const handleSectionUpdate = (sectionName, sectionData) => {
    setFormData((prev) => ({
      ...prev,
      [sectionName]: sectionData,
    }));
  };

  const handleSave = () => {
    const sanitizedData = sanitizeData(formData, defaultStructure);
    onSave({ pageName: data.pageName, content: sanitizedData });
  };

  return (
    <div className="col-12">
      {alert.show && (
        <Alert
          variant={alert.variant}
          dismissible
          onClose={() => setAlert({ show: false, message: "", variant: "info" })}
          className="mb-3"
        >
          {alert.message}
        </Alert>
      )}

      <div className="card p-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="d-flex align-items-center">
            <Button variant="link" className="p-0 me-3" onClick={onCancel}>
              ← Back
            </Button>
            <h4 className="m-0">Edit {data?.pageName || "Page"}</h4>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <HeroSection
              data={formData.heroSection}
              onUpdate={(updatedData) => handleSectionUpdate("heroSection", updatedData)}
            />

            <MetaSection
              data={formData.meta}
              onUpdate={(updatedData) => handleSectionUpdate("meta", updatedData)}
            />

            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={onCancel}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleSave} disabled={isLoading}>
                {isLoading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Saving...
                  </>
                ) : (
                  "Save Changes"
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleMainPageEditor;
